import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Features from '../components/Features';
import WorkflowDemo from '../components/WorkflowDemoComponent';
import CTA from '../components/CTA';
import AnimatedBackground from '../components/AnimatedBackground';
import ImpactAndAudience from '../components/ImpactAndAudience';
import Footer from '../components/Footer';

const Index = () => {
  // Scroll reveal logic
  useEffect(() => {
    const handleScroll = () => {
      const reveals = document.querySelectorAll('.reveal');
      
      for (let i = 0; i < reveals.length; i++) {
        const windowHeight = window.innerHeight;
        const revealTop = reveals[i].getBoundingClientRect().top;
        const revealPoint = 150;
        
        if (revealTop < windowHeight - revealPoint) {
          reveals[i].classList.add('active');
        }
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    // Initial check
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  return (
    <div className="min-h-screen w-full overflow-hidden">
      {/* Background effects */}
      <AnimatedBackground />
      
      {/* Main content */}
      <Navbar />
      <Hero />
      <WorkflowDemo />
      <Features />
      <ImpactAndAudience />
      <CTA />
      
      <Footer />
    </div>
  );
};

export default Index;
